import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../../store/context/SocketProvider";
import sound from "../../../assets/sounds/Ringing.mp3";

export default function GroupCallModal(props) {
  const navigate = useNavigate();
  const {
    isOpen,
    toggleCallModal,
    isVideo,
    user,
    inComming,
    caller,
    currentUser,
    conversationId,
    updateMessages,
  } = props;

  const [isCalling, setIsCalling] = useState(false);
  const audioRef = useRef(null);
  const { startGroupCall, answerGroupCall, socket } = useSocket();

  const controlAudio = (action = "stop") => {
    if (!audioRef.current) return;
    if (action === "play") {
      audioRef.current.volume = inComming ? 1 : 0.3;
      audioRef.current.loop = true;
      audioRef.current.play();
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const onClose = () => {
    controlAudio("stop");
    setIsCalling(false);
    toggleCallModal();
    if (isCalling) {
      const messageObj = {
        sender: currentUser?._id,
        receiver: user?._id,
        message: "",
        media: [],
        conversationId,
        updatedAt: new Date().toLocaleString(),
        createdAt: new Date().toLocaleString(),
        callInfo: {
          isCall: true,
          callType: isVideo ? "Video" : "Audio",
          duration: "00:00",
          time: new Date().toLocaleString(),
        },
      };
      console.log("end with", messageObj, updateMessages);
      updateMessages(messageObj);
      socket?.emit("sendMessageGroup", messageObj);
    }
  };

  const onCall = (type) => {
    controlAudio("play");
    setIsCalling(true);
    startGroupCall(user.members, user, type, conversationId);
  };

  const answer = async () => {
    controlAudio("stop");
    await answerGroupCall();
    navigate("/messenger/videomeeting-session");
  };

  useEffect(() => {
    audioRef.current = new Audio(sound);
    if (inComming) controlAudio("play");
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const callTypeLabel = isVideo ? "Video Call" : "Audio Call";
  const callStatus = inComming
    ? `${caller?.contactName?.first ?? "Someone"} is calling...`
    : isCalling
    ? "Calling..."
    : `Start ${callTypeLabel}`;

  if (!isOpen) return null;

  return (
    <div className="ct-toast" role="dialog" aria-label="Group call notification">

      <div className="ct-header">
        <div className="ct-header-left">
          <span className="ct-badge">
            {inComming ? "Incoming" : isCalling ? "Outgoing" : "New Call"}
          </span>
          <p className="ct-header-title">Group {callTypeLabel}</p>
        </div>
        <button className="ct-dismiss" onClick={onClose} aria-label="Dismiss">
          &#x2715;
        </button>
      </div>

      <div className="ct-body">
        <div className="ct-identity">
          <div className="ct-avatar-wrap">
            <img
              className="ct-avatar"
              src="https://static.vecteezy.com/system/resources/thumbnails/021/063/599/small/group-coaching-icon-vector.jpg"
              alt={user?.name ?? "Group"}
            />
            <div className="ct-avatar-ring" />
            <div className="ct-type-badge">
              <i className={isVideo ? "ion-md-videocam" : "ri-phone-fill"} style={{ fontSize: 9 }} />
            </div>
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <p className="ct-name">{user?.name ?? "Group"}</p>
            <p className="ct-status">
              <span className="ct-pulse" />
              {callStatus}
            </p>
          </div>
        </div>

        <div className="ct-divider" />

        <div className="ct-actions">
          <button className="ct-btn ct-btn-decline" onClick={onClose}>
            <i className="ri-close-fill" style={{ fontSize: 13 }} />
            {inComming ? "Decline" : "End"}
          </button>

          {inComming && (
            <button className="ct-btn ct-btn-confirm" onClick={answer}>
              <i className={isVideo ? "ion-md-videocam" : "ion-md-call"} style={{ fontSize: 13 }} />
              Answer
            </button>
          )}

          {!inComming && !isCalling && (
            <button
              className="ct-btn ct-btn-confirm"
              onClick={() => onCall(isVideo ? "video" : "audio")}
            >
              <i className={isVideo ? "ion-md-videocam" : "ri-phone-fill"} style={{ fontSize: 13 }} />
              {isVideo ? "Start Video" : "Start Call"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}